import { render, staticRenderFns } from "./comScreen.vue?vue&type=template&id=02dd7f3d&scoped=true&"
import script from "./comScreen.vue?vue&type=script&lang=js&"
export * from "./comScreen.vue?vue&type=script&lang=js&"
import style0 from "./comScreen.vue?vue&type=style&index=0&id=02dd7f3d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd7f3d",
  null
  
)

export default component.exports